'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runWithLowPriority = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Scheduler = _react2.default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Scheduler;


var runWithLowPriority = function runWithLowPriority(cb) {
  return Scheduler.unstable_runWithPriority(Scheduler.unstable_LowPriority, function () {
    cb();
  });
};

exports.runWithLowPriority = runWithLowPriority;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.2431/js/internal/Scheduler.js
// module id = 405
// module chunks = 3 4